import {
  CANDIDATE_SUMMARY__INCLUDE_FLAGS
} from '../../../components/Candidates/SubmissionNotes.lib';
import {
  ID__ATS_TYPE__ASHBY_API,
  ID__ATS_TYPE__GH_HARVEST,
  ID__ATS_TYPE__LEVER_API
} from "../../Definition";
import {
  Obj
} from '../../Object.lib';
import Ashby from './Ashby.lib';
import Greenhouse from "./Greenhouse.lib";
import Lever from './Lever.lib';

/* METHODS ==================================== */

/**
 * Handler event on click "Submit to ATS" green button
 *
 * @param {Object} params
 * @param {Object} params.candidate
 * @param {Object} params.job
 * @param {Object} params.emailParams
 * @param {Object} params.emailParams.from
 * @param {Object} params.emailParams.to
 * @param {Object} params.emailParams.subject
 * @param {Object} params.emailParams.html
 * @param {Object} params.submissionNotes
 * @param {string} params.submissionNotes.public
 * @param {string} params.submissionNotes.private
 * 
 * @returns A promise.
 */
async function sendToATS({
  candidate = {},
  job = {},
  emailParams = {},
  submissionNotes = {},
}) {

  const employer = Obj(job.employer);
  const atsTypeId = parseInt(employer.atsTypeId);

  if (atsTypeId === ID__ATS_TYPE__LEVER_API) {
    return Lever.submit({
      candidate,
      job,
      emailParams
    });
  }

  if (atsTypeId === ID__ATS_TYPE__ASHBY_API) {
    return Ashby.submit({
      candidate,
      job,
      emailParams,
      submissionNotes: submissionNotes.public,
    });
  }

  if (atsTypeId === ID__ATS_TYPE__GH_HARVEST) {
    return Greenhouse.submit({
      candidate,
      job,
      emailParams,
      submissionNotesPublic: submissionNotes.public,
      submissionNotesPrivate: submissionNotes.private
    });
  }

}

/**
 * Getting public and private notes
 * from raw submission notes
 *
 * @param {*} param0
 * @returns
 */
function makeSubmissionNotes({
  candidate = {},
  rawSubmissionNotes
}) {

  const submissionNotes = {
    public: [],
    private: []
  };

  rawSubmissionNotes
    .split('\n')
    .map(
      // Fixes spacing in key: value pairs,
      // preserving valid URLs
      (line) => line.replace(
        /(^|\s)([^:\s]+):\s*(?!\/\/)/g,
        '$1$2: '
      )
    )
    .filter(n => {
      if (
        !n ||
        !!n.match(/CANDIDATE SUBMISSION:/i) ||
        !!n.match(/salary/i)
      ) {
        return false;
      }
      if (
        !!n.match(/visa/i) ||
        !!n.match(/work authorization/i)
      ) {
        submissionNotes.private.push(n);
      }
      else {
        submissionNotes.public.push(n);
      }
      return true;
    })
    .join('\n');

  if (candidate.submissionIncludeFlags.includes(CANDIDATE_SUMMARY__INCLUDE_FLAGS.minimumSalary)) {
    submissionNotes.private.push([
      'Compensation expectation: ',
      candidate._minimumSalary,
      candidate.salaryNote ? ' - ' + candidate.salaryNote : ''
    ].join(''));
  }

  submissionNotes.public = submissionNotes.public.join('\n');
  submissionNotes.private = submissionNotes.private.join('\n');

  /** µ FOR DEBUG PURPOSES * /
  console.debug('µ', {
    rawSubmissionNotes,
    submissionNotes,
  });
  /** */

  return submissionNotes;

}

/* DICTIONARIES =============================== */

const AtsLib = {
  send: sendToATS,
  makeSubmissionNotes,
}

/* EXPORTS ==================================== */

export {
  AtsLib, AtsLib as default, makeSubmissionNotes as makeAtsSubmissionNotes, sendToATS
};

/* ============================================ */
